import Status from './Status.vue'
import FileType from './FileType.vue'
import ShowType from './ShowType.vue'
import Data from './Data.vue'
export const columns = [
  {
    title: 'route.exportTask',
    index: 'taskName'
  },
  {
    title: 'integration.state',
    index: 'status',
    component: Status
  },
  {
    title: 'public.demonstrations',
    index: 'showType',
    component: ShowType
  },
  {
    title: 'public.data',
    index: 'data',
    component: Data,
    width: 300,
  },
  {
    title: 'integration.file_type',
    index: 'fileType',
    component: FileType,
    width: 80
  },
]
